import React from 'react';
import { IUseDataContextProps } from './useDataContext';

export const DataContext = React.createContext<IUseDataContextProps>(null);